module.exports = __webpack_public_path__ + "static/media/_switzerland.fda09c52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_switzerland.svg
// module id = 2355
// module chunks = 7